module.exports = require('./$').hide;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/$.redef.js
 ** module id = 20
 ** module chunks = 0
 **/